import React, { memo } from 'react';
import getPercent from '../../../../utils/getPercent';

const StatsRowComponent = ({ approvals, noApprovals, columns }) => {
  const approvalsReturned = approvals.filter(approval => approval.getIn(['dateReceived', 'value'], 0) !== null);
  const mergedApprovalsWithNoApprovals = approvals.concat(noApprovals);

  const renderCell = (column, i, data, total = false) => {
    if (i === 2) return null;

    if (column.get('field') === 'applistLabel') {
      return (
        <td key={column.get('field')} colSpan="2">
          Total ({total ? 'All' : 'Returned Approval Lists'}):
        </td>
      );
    }

    if (column.get('field') === 'dateSent') {
      return <td key={column.get('field')} />;
    }

    const sum = getSum(data, column.get('field'));
    const percent = (() => {
      if (column.get('field') === 'numberApproved') {
        return getPercent(sum, getSum(data, 'numberTargets'));
      }

      if (['numberOfContacted', 'numberOfLeads', 'numberOfCc', 'numberOfVisit'].includes(column.get('field'))) {
        return getPercent(sum, getSum(data, 'numberApproved'));
      }

      if (
        [
          'numberOfNextActions',
          'numberOfPriorityA',
          'numberOfPriorityB',
          'numberOfPriorityC',
          'numberOfApprovedX',
        ].includes(column.get('field'))
      ) {
        return getPercent(sum, getSum(data, 'numberTargets'));
      }

      return null;
    })();

    const content =
      percent !== null ? (
        <>
          {sum} ({percent}%)
        </>
      ) : (
        sum
      );

    const alignment =
      column.get('field').startsWith('numberOfPriority') || column.get('field') === 'numberOfApprovedX'
        ? 'text-center'
        : 'text-right';

    return (
      <td key={column.get('field')} className={alignment}>
        {content}
      </td>
    );
  };

  const cellsReturned = columns.map((column, i) => renderCell(column, i, approvalsReturned));
  const cellsTotal = columns.map((column, i) => renderCell(column, i, mergedApprovalsWithNoApprovals, true));

  return (
    <tfoot>
      <tr className="stats-row font-bold">{cellsReturned}</tr>
      <tr className="stats-row">{cellsTotal}</tr>
    </tfoot>
  );
};

const getSum = (data, field) => data.reduce((sum, item) => sum + item.get(field, 0), 0);

export const StatsRow = memo(StatsRowComponent);
